/**
 * Exclusive Elite family dashboard (mirrors `/elite-prime-family-dashboard` with Elite locked).
 *
 * Belongs here: Elite-locked member dashboard with a family status query key.
 * Does not belong here: family purchase CTA (see `/elite-family-landing`).
 */
import '../elitePlansTheme.css'
import { ELITE_PLANS_ELITE_TAB_ID, ElitePlansLandingProvider } from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ELITE_FAMILY_DASHBOARD_STATUS_QUERY_KEY } from '../constants/queryKeys'
import { ElitePlansPageShell } from '../components/ElitePlansPageShell'
import { ElitePrimeDashboardHeader } from '../components/ElitePrimeDashboardHeader'
import { ElitePlansEliteMemberDashboard } from '../components/ElitePlansEliteMemberDashboard'
import { NewEliteLandingAnalyticsScreen } from '../../new-elite-landing/analytics/newEliteLandingAnalytics'

export default function ElitePlansEliteFamilyDashboardPage() {
  return (
    <ElitePlansLandingProvider
      analyticsScreen={ElitePlansAnalyticsScreen.EliteFamilyDashboard}
      lockedPlanId={ELITE_PLANS_ELITE_TAB_ID}
      statusQueryKeyRoot={ELITE_FAMILY_DASHBOARD_STATUS_QUERY_KEY}
    >
      <ElitePlansEliteFamilyDashboardPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePlansEliteFamilyDashboardPageContent() {
  // ScreenLoaded fires from ElitePlansEliteMemberDashboard when advisory status is ready
  return (
    <ElitePlansPageShell>
      <ElitePrimeDashboardHeader accent='elite' showPlanTab={false} />
      <ElitePlansEliteMemberDashboard
        statusQueryKeyRoot={ELITE_FAMILY_DASHBOARD_STATUS_QUERY_KEY}
        analyticsScreen={NewEliteLandingAnalyticsScreen.FamilyDashboard}
      />
    </ElitePlansPageShell>
  )
}
